<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="illustrations">LIST OF ILLUSTRATIONS</p>
<p class="list"><a href="#/xhtml/frontispiece#frontispiece">Battle of Atlanta Lithograph</a></p>
<p class="list"><a href="#/xhtml/introduction#major">Major General William T. Sherman, U.S.A.</a></p>
<p class="list"><a href="#/xhtml/introduction#car">Car Shed, in Downtown Atlanta, 1864</a></p>
<p class="list"><a href="#/xhtml/chapter1#james">Major General James B. McPherson, U.S.A.</a></p>
<p class="list"><a href="#/xhtml/chapter1#john">General John Bell Hood, C.S.A.</a></p>
<p class="list"><span href="#/xhtml/chapter2#bri" title="Link target outside of Sample">Brigadier General Mortimer D. Leggett, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter3#william" title="Link target outside of Sample">Lieutenant General William J. Hardee, C.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter4#gren" title="Link target outside of Sample">Major General Grenville M. Dodge, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter4#bate" title="Link target outside of Sample">Major General William B. Bate, C.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter5#joseph" title="Link target outside of Sample">Major General Joseph Wheeler, C.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter6#fell" title="Link target outside of Sample">Place where General McPherson fell</span></p>
<p class="list"><span href="#/xhtml/chapter7#pat" title="Link target outside of Sample">Major General Patrick R. Cleburne, C.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter7#force" title="Link target outside of Sample">Brigadier General Manning F. Force, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter8#photo" title="Link target outside of Sample">Confederate earthworks at the Georgia Railroad</span></p>
<p class="list"><span href="#/xhtml/chapter9#logan" title="Link target outside of Sample">Major General John A. Logan, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter9#walcutt" title="Link target outside of Sample">Colonel Charles C. Walcutt, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter10#xvii" title="Link target outside of Sample">Major General Frank Blair and his XVII Corps staff, U.S.A.</span></p>
<p class="list"><span href="#/xhtml/chapter11#atlanta" title="Link target outside of Sample">The Atlanta Cyclorama: The 1886 Memorial of the Battle of Atlanta</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustrations.vue?35cca4a0